var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPromptsShowCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#2D3245"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6577 24.1903C10.6825 24.3814 10.9601 24.3814 10.9842 24.1903C11.174 22.7024 12.3454 21.5316 13.8327 21.3418C14.0245 21.317 14.0245 21.0394 13.8327 21.0153C12.3455 20.8255 11.1741 19.6541 10.9842 18.1668C10.9601 17.975 10.6825 17.975 10.6577 18.1668C10.4679 19.654 9.29717 20.8254 7.8092 21.0153C7.61742 21.0394 7.61742 21.317 7.8092 21.3418C9.29713 21.5316 10.4678 22.7023 10.6577 24.1903Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5014 20.4825C17.5457 20.8278 18.0452 20.8278 18.0895 20.4825C18.4885 17.3578 20.9486 14.8969 24.074 14.4987C24.4193 14.4544 24.4193 13.9542 24.074 13.9106C20.9486 13.5117 18.4884 11.0508 18.0895 7.92612C18.0452 7.58079 17.5457 7.58079 17.5014 7.92612C17.1031 11.0508 14.6423 13.5117 11.5169 13.9106C11.1723 13.9542 11.1723 14.4544 11.5169 14.4987C14.6423 14.897 17.1032 17.3578 17.5014 20.4825Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromptsShowCircle);
export default __webpack_public_path__ + "static/media/prompts-show-circle.ccf666bd24ad3e0301562e9f5cdf146d.svg";
export { ForwardRef as ReactComponent };